import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ClickhouseService } from '../../../../../shared/services/clickhouse.service';

@Component({
  selector: 'app-mark-solved-message',
  templateUrl: './mark-solved-message.component.html',
  styleUrls: ['./mark-solved-message.component.scss'],
})
export class MarkSolvedMessageComponent implements OnInit {
  @Output() questionAsked = new EventEmitter<any>();

  @Output() markedAsDone = new EventEmitter<any>();

  constructor(private clickHouse: ClickhouseService) {}

  ngOnInit(): void {
    this.clickHouse.storeEvent('any_question_for_previous_task_message_shown').subscribe(() => {});
  }

  askQuestion() {
    this.questionAsked.emit();
  }

  markAsDone() {
    this.markedAsDone.emit();
  }
}
